<div
  fxLayout="column"
  fxLayoutAlign="center center"
  class="contact-page-container"
>
  <div
    fxLayout="row wrap"
    fxLayoutAlign="center center"
    fxLayoutAlign.gt-sm="space-between center"
    class="contact-page-bottom-section"
  >
    <app-contact-form-base title="Contact"></app-contact-form-base>
    <div
      fxLayout="column"
      fxLayoutAlign="space-around center"
      class="contact-details-container"
    >
      <h2>
        Birou vânzări
      </h2>
      <address
        fxLayout="column"
        fxLayoutAlign="center start"
        class="contact-details"
      >
        <a
          [href]="'tel:' + agencyService.agency.phone"
          target="_blank"
          fxLayout="row"
          fxLayoutAlign="start center"
          class="contact-item"
          appGtagEvent
          eventCategory="contact"
          eventAction="click"
          eventLabel="phone_click"
          appFbqEvent="Contact"
          [customData]="{content_name: 'phone_click', content_category: 'click'}"
        >
          <img alt="" src="/assets/icons/contact/phone.svg" loading="lazy">
          {{ agencyService.agency.phone | beautify }}
        </a>
        <a
          [href]="'https://maps.google.com?daddr='
          + agencyService.agency.latitude + ','
          + agencyService.agency.longitude + '&amp;ll='"
          target="_blank"
          fxLayout="row"
          fxLayoutAlign="start center"
          class="contact-item"
          appGtagEvent
          eventCategory="contact"
          eventAction="click"
          eventLabel="maps_click"
          appFbqEvent="Contact"
          [customData]="{content_name: 'maps_click', content_category: 'click'}"
        >
          <img alt="" src="/assets/icons/contact/location.svg" loading="lazy">
          {{ agencyService.agency.address }}
        </a>
        <a
          [href]="'mailto:' + agencyService.agency.email"
          target="_blank"
          fxLayout="row"
          fxLayoutAlign="start center"
          class="contact-item"
          appGtagEvent
          eventCategory="contact"
          eventAction="click"
          eventLabel="email_click"
          appFbqEvent="Contact"
          [customData]="{content_name: 'email_click', content_category: 'click'}"
        >
          <img alt="" src="/assets/icons/contact/email.svg" loading="lazy">
          {{ agencyService.agency.email }}
        </a>
      </address>
    </div>
    <div
      class="google-map"
      fxLayout="column"
      fxLayout.gt-sm="row"
      fxLayoutAlign="center center"
    >
      <app-google-map-iframe
        [latitude]="agencyService.agency.latitude"
        [longitude]="agencyService.agency.longitude"
      >
      </app-google-map-iframe>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.html